import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Um bloco de página: título curto em caixa alta, uma linha até a borda, e o conteúdo.
 *
 * O título é de seção, não de cartão — ele agrupa; os cartões dentro é que nomeiam. É o
 * que separa "Precisa de atenção" de "Equipe" no painel, e "Em andamento" de
 * "Encerradas" nas obras: perguntas diferentes, não cartões iguais empilhados.
 */
export function Section({
  title,
  count,
  description,
  children,
  className,
}: {
  title: string;
  /** Quantos itens o bloco tem, quando isso é informação — "Em andamento · 4". */
  count?: number;
  description?: string;
  children: ReactNode;
  className?: string;
}) {
  const id = `secao-${title.toLowerCase().replaceAll(/[^a-z0-9]+/gu, '-')}`;
  return (
    <section aria-labelledby={id} className={cn('flex flex-col gap-3', className)}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <h2
            id={id}
            className="shrink-0 text-[11px] font-semibold uppercase tracking-[0.08em] text-(--color-content-muted)"
          >
            {title}
            {count !== undefined && (
              <span className="tabular font-medium normal-case tracking-normal"> · {count}</span>
            )}
          </h2>
          <div className="h-px flex-1 bg-(--color-border-subtle)" aria-hidden="true" />
        </div>
        {description !== undefined && (
          <p className="text-xs text-(--color-content-muted)">{description}</p>
        )}
      </div>
      {children}
    </section>
  );
}
